// ----------------------------------------------------------------------------
//   Imports
// ----------------------------------------------------------------------------

// React
import { forwardRef } from 'react';

// Material UI
import {
  Box,
} from "@mui/material";



// ----------------------------------------------------------------------------
//   Component
// ----------------------------------------------------------------------------

export const AligningBox = forwardRef(({
  alignX = "center",
  alignY = "center",
  children,
  ...boxProps
}, ref) => {

  const alignItemsMap = {
    'top':    'start',
    'bottom': 'end',
  }

  return (
    <Box ref={ ref }
      position       = "absolute"
      height         = "100%"
      width          = "100%"
      display        = "flex"
      justifyContent = { alignX }
      alignItems     = { alignItemsMap[ alignY ] ?? alignY }
      zIndex = "99"
      { ...boxProps }
    >
      { children }
    </Box>
  )
})



// ----------------------------------------------------------------------------
//   Export(s)
// ----------------------------------------------------------------------------

export default AligningBox;
